import { render } from "./Widget6.vue?vue&type=template&id=089ae1ae"
import script from "./Widget6.vue?vue&type=script&lang=js"
export * from "./Widget6.vue?vue&type=script&lang=js"
script.render = render

export default script